export default __webpack_public_path__ + "static/media/cdp-logo-coloured_1.4b629eb0.svg";